module.exports = __webpack_public_path__ + "static/media/BRAG.07dfcc9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/BRAG.png
// module id = 354
// module chunks = 0